import ACTION_TYPES from "../actions/type.action";

const initialState = {
  dashboard: {
    // firstName: "Alexa",
    // lastName: "Dot",
    // email: "student2@cybernetyx.com",
    // studentId: "KNEU-IPJ-00000005",
    // birthPlace: {
    //   state: "Haryana"
    // },
    // family: {
    //   fatherOccupation: "Teacher",
    //   fatherEducation: "B.Comm",
    //   motherOccupation: "House Wife",
    //   motherEducation: "B.Comm",
    //   socialEconomicClass: "Mast hai"
    // },
    // interest: {
    //   english: "High",
    //   maths: "Hign",
    //   science: "High",
    //   arts: "Medium",
    //   sports: "Medium"
    // },
    // language: {
    //   primary: "English",
    //   secondary: "Hindi"
    // },
    // personalDetails: {
    //   dateOfBirth: "July 23, 1996",
    //   gender: "Male"
    // },
    // medical: {
    //   bloodGroup: "B+",
    //   height: 164,
    //   weight: 68
    // },
    // content: {
    //   preference: "Animated",
    //   teachingMethodology: "Theoritical"
    // }
    firstName: "",
    lastName: "",
    email: "",
    profile_url: "",
    studentId: "",
    birthPlace: {
      state: ""
    },
    family: {
      fatherOccupation: "",
      fatherEducation: "",
      motherOccupation: "",
      motherEducation: "",
      socialEconomicClass: ""
    },
    interest: {
      english: "",
      maths: "",
      science: "",
      arts: "",
      sports: ""
    },
    language: {
      primary: "",
      secondary: ""
    },
    personalDetails: {
      dateOfBirth: "",
      gender: ""
    },
    medical: {
      bloodGroup: "",
      height: "",
      weight: ""
    },
    content: {
      preference: "",
      teachingMethodology: ""
    }
  }
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case ACTION_TYPES.FETCH_STUDENT_PROFILE:
      return { ...state, dashboard: { ...payload } };
    case ACTION_TYPES.UPDATE_STUDENT_PROFILE:
      return { ...state, dashboard: { ...payload } };
    default:
      return state;
  }
};

export default reducer;
